import React, { useState } from "react";
import "./AutomateTransaction.css";

export default function AutomateTransaction() {
  const [formData, setFormData] = useState({
    depositLimit: 10,
    withdrawLimit: 10,
    autoApprove: 1,
    transactionType: "Manual",
    transactionTime: 24,
    showBank: "Yes",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    alert("Settings Updated!");
  };

  return (
    <div className="transaction-page">
      {/* Page Header */}
      <div className="page-header">
        <h2>Automate Transaction Settings</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / <a href="/app-settings">App Settings</a> / CRM Automation Settings
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h3>Update Transaction Automation Setting</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Deposit Limit</label>
              <input
                type="number"
                name="depositLimit"
                value={formData.depositLimit}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Withdraw Limit</label>
              <input
                type="number"
                name="withdrawLimit"
                value={formData.withdrawLimit}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Auto Approve Amount</label>
              <input
                type="number"
                name="autoApprove"
                value={formData.autoApprove}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Transaction Type</label>
              <select
                name="transactionType"
                value={formData.transactionType}
                onChange={handleChange}
              >
                <option value="Manual">Manual</option>
                <option value="Auto">Auto</option>
              </select>
            </div>

            <div className="form-group">
              <label>Transaction Time</label>
              <input
                type="number"
                name="transactionTime"
                value={formData.transactionTime}
                onChange={handleChange}
              />
              <small>Enter Time in hours. i.e. for 72 hour enter 72</small>
            </div>

            <div className="form-group">
              <label>Show Bank</label>
              <select
                name="showBank"
                value={formData.showBank}
                onChange={handleChange}
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <small>Show/Hide Bank option in deposit page</small>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="update-btn">Update</button>
          </div>
        </form>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}

